import { object, string } from 'yup'

const constructionCompanySchema = object({
  name: string()
    .required('Name ist erforderlich')
    .min(1, 'Name muss mindestens 1 Zeichen lang sein'),
  street: string(),
  zip_code: string(),
  city: string(),
})

export { constructionCompanySchema }
